import { Typography } from '@material-tailwind/react'
import AddAgamiToPatternRow from './AddAgamiToPatternRow'
import { AgamiSpot } from '../types/supabase'

const TABLE_HEAD = ['Agami Name', 'Agami Description', 'Created', 'Add to pattern']

interface AddAgamiToPatternTableProps {
  currentExpId: string
  currentPatternId: string
  refetchAfterChange: () => Promise<void>
  agamiList: AgamiSpot[]
}

const AddAgamiToPatternTable: React.FC<AddAgamiToPatternTableProps> = ({
  currentExpId,
  currentPatternId,
  refetchAfterChange,
  agamiList,
}) => (
  <table className="w-full">
    <thead>
      <tr>
        {TABLE_HEAD.map((head) => (
          <th
            key={head}
            className="border-blue-gray-100 bg-blue-gray-500/30 dark:bg-primary-600 border-b p-4"
          >
            <Typography variant="small" className="font-bold leading-none">
              {head}
            </Typography>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {agamiList.map((agami) => (
        <AddAgamiToPatternRow
          key={agami.id}
          id={agami.id}
          name={agami.name}
          description={agami.description}
          inserted_at={agami.inserted_at}
          experience_content_spots={agami.experience_content_spots || []}
          currentPatternId={currentPatternId}
          currentExpId={currentExpId}
          refetch={refetchAfterChange}
        />
      ))}
    </tbody>
  </table>
)

export default AddAgamiToPatternTable
